import React from 'react';
import style from './style';
import i18next from 'i18next';
import EAButton from '../../../common/EAButton';
import clsx from 'clsx';

const ContextInfos = ({
  onEdit,
  category,
  title,
  subtitle,
  displayModifyButton = true,
}) => {
  const { classes } = style();
  const shouldDisplay = title !== '';

  return (
    <>
      {shouldDisplay ? (
        <div
          className={clsx(
            classes.itemWrapper,
              category ? classes.titleMargin : classes.noTitleMargin
          )}
        >
          {category ? <div className={classes.itemTitle}>{category}</div> : <></>}
          <div className={classes.item}>
            <div className={classes.contextWrapper}>
              <div className={classes.modelName}>
                {title}
              </div>
              {subtitle ? (
                <div className={classes.reference}>{subtitle}</div>
              ) : (
                <></>
              )}
            </div>
            {displayModifyButton ? (
              <EAButton
                onClick={onEdit}
                colorVariant={'secondary'}
                content={i18next.t('context.modifier')}
                size={'xs'}
                customStyle={{
                  marginLeft: 'auto',
                }}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default ContextInfos;
